<!--我的页面-->
<template>
    <div class="id">
        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf">
            <van-tab v-for="(item, index) in source" :key="index" :title="item.name">
                <div v-show="index == 0" class="overview">
                    <div class="universal">
                        <van-field v-model="searchValue" :label="$t('支付金额')" :border="false" :placeholder="$t('请输入')" />
                        <div style="color: #07ecfe;white-space: nowrap;">ABPAY</div>
                    </div>
                    <div style="color: #07ecfe;padding: 10px 0 30px 5px;">
                        1-100000000 ABPAY
                    </div>
                    <div class="universal">
                        <van-field v-model="searchValue" :label="this.$t('收到金额')" :border="false"
                            :placeholder="$t('请输入')" />
                        <div style="color: #07ecfe;white-space: nowrap;">USDT</div>
                    </div>
                    <div style="color: #07ecfe;padding: 10px 0 30px 5px;">
                        1 ≈ ABPAY
                    </div>
                    <van-button type="primary" class="btn">{{ $t('购买') }}</van-button>
                    <div style="color: #07ecfe;padding:20px 0;text-align: center;"
                        @click="$router.push('/mobile/history')">{{ $t('历史账单') }}</div>
                </div>
                <div v-show="index != 0" class="overview">
                    <div class="universal">
                        <van-field v-model="searchValue" :label="$t('出售金额')" :border="false" :placeholder="$t('请输入')" />
                        <div style="color: #07ecfe;white-space: nowrap;">ABPAY</div>
                    </div>
                    <div style="color: #07ecfe;padding: 10px 0 30px 5px;">
                        {{ $t('可用余额') }}0
                    </div>
                    <div class="universal">
                        <van-field v-model="searchValue" :label="$t('收到金额')" :border="false" :placeholder="$t('请输入')" />
                        <div style="color: #07ecfe;white-space: nowrap;">USDT</div>
                    </div>
                    <div style="color: #07ecfe;padding: 10px 0 30px 5px;">
                        1 ≈ ABPAY
                    </div>
                    <van-button type="primary" class="btn">{{ $t('出售') }}</van-button>
                    <div style="color: #07ecfe;padding:20px 0;text-align: center;"
                        @click="$router.push('/mobile/history')">{{ $t('历史账单') }}</div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api'

export default {
    components: {
    },
    data() {
        return {
            checked: false,
            searchValue: '',
            active: 0,
            indexS: 0,
            source: [
                {
                    name: this.$t('购买')
                },
                {
                    name: this.$t('出售')
                }
            ],
        };
    },
    mounted() {
        this.quickData()
    },
    beforeUnmount() { },
    methods: {
        async quickData() {
            const res = await get(apis.quickData)
            if (res.code == 1) {
                console.log(res.data, '444');
                return
            }
            this.$toast(res.msg);
        },
        onChange(name, title) {
            console.log("切换到", name, title)
        },
        timeCk(index) {
            this.indexS = index
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
    background-color: #000;
}

::v-deep .van-cell__value {
    margin-right: 10px;
}

::v-deep .van-field__label {
    width: auto;
    color: #fff;
}

::v-deep .van-field__control {
    color: #888;
}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 60px;
    padding-top: 50px;
    font-size: 14px;

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #1e1e2f;
        margin-top: 10px;
    }



    .overview {
        border-radius: 10px;
        padding: 20px 15px;
        margin-top: 15px;
        border: 1px solid #2b2b3d;
        background-color: #1f1f2f;

        .universal {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 5px;
            background-color: #000;
        }

        .btn {
            background-color: #00f0ff;
            width: 100%;
            color: #000;
            border-radius: 10px;
            font-weight: 700;
            font-size: 16px;
        }

    }
}
</style>
